import React from 'react';
import { useParams } from 'react-router-dom'; // Import useParams to access URL parameters

function FilteredSurvey() {
  // Access URL parameters
  const { country, category, difficulty } = useParams();

  // Function to capitalize the first letter of a string
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  // Display selected filtering options in the header
  return (
    <div className="container">
      <div className="card mt-4">
        <div className="card-body">
          <h2>Filtered Surveys</h2>
          <h3>Selected Options:</h3>
          {country && <p>Country: {capitalizeFirstLetter(country)}</p>}
          {category && <p>Culture Category: {capitalizeFirstLetter(category)}</p>}
          {difficulty && <p>Difficulty Level: {capitalizeFirstLetter(difficulty)}</p>}
        </div>
      </div>
    </div>
  );
}

export default FilteredSurvey;
